import React, { useEffect, useState } from "react";
import { FormHelperText, Grid, Typography } from "@mui/joy";
import Button from "@mui/joy/Button";
import SvgIcon from "@mui/joy/SvgIcon";
import { fileUploadDocumentsValidationSchema } from "../../../validations/validationScemas";
import { useFormik } from "formik";
import { PostChat } from "../../../services/apiServices"
import { networkUrls } from "../../../services/networkurls";
import { styled } from "@mui/joy";
import ReuseableButton from "../../../components/Button/ReusableButton";
import ReuseableSnackbar from "../../../components/Snackbar/Snackbar";
import DocumentsTable from "../../../components/Table/Table";
import ReusableModal from "../../../components/ReusableModal/ReusableModal";
import UserModal from "../../../components/UserModal/UserModal";
import DownloadIcon from "@mui/icons-material/Download";
const VisuallyHiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;
const Users = () => {
  const [isShowSnackbar, setIsShowSnackbar] = useState(false);
  const [openModal, setOpenModal] = useState({ isOpen: false, type: "" });
  const [triggerGetCall, setTrigegerGetCall] = useState(0);
  const [showMissingModal, setShowMissingModal] = useState(false);
  const [missingCategoryMessage, setMissingCategoryMessage] = useState("");
  const [modalType, setModalType] = useState("");
  const [isProceed, setIsProceed] = useState(false);
  const [userData, setUserData] = useState({});

  const [snackbarInfo, setSnackbarInfo] = useState({
    color: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const formik: any = useFormik({
    initialValues: {
      files: [],
    },
    validationSchema: fileUploadDocumentsValidationSchema,
    validateOnChange: true,
    onSubmit: () => {
      handleSubmit();
    },
  });

  const handleSuccess = (response: any) => {
    setSnackbarInfo({
      color: "success",
      message: response?.data?.message,
    });
    setIsShowSnackbar(true);
    formik.resetForm();
    setTrigegerGetCall((prev) => prev + 1);
    formik.setFieldValue("files", []);
  };

  const handleFailure = (res: any) => {
    setSnackbarInfo({
      color: "error",
      message: res?.data?.detail || "Something went wrong. Please try again.",
    });
    setIsShowSnackbar(true);
  };

  const handleSubmit = async () => {
    setLoading(true);

    const fd: any = new FormData();
    if (formik?.values?.files && Array.isArray(formik.values.files)) {
      formik.values.files.forEach((file: any) => {
        if (file instanceof File) {
          fd.append("file", file);
        }
      });
    }

    try {
      const response = await PostChat(`/api${networkUrls.uploadAllowedUsers}`, fd, true);

      if (response?.status === 200) {
        handleSuccess(response);
      } else if (response !== null) {
        // Only show local snackbar if response exists but status is not 200
        // If response is null, error was already handled by global snackbar in Post function
        handleFailure(response);
      }
    } catch (error: any) {
      console.error("Upload Error:", error?.response?.data?.detail );
      // handleFailure(error?.response);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = "/users.csv";
    link.download = "users-sample.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Grid className="file-upload-container">
          <Grid sx={{ display: "flex", flexDirection: "column" }}>
            <Grid sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 1 }}>
              <Typography
                component="label"
                fontWeight="bold"
                style={{ color: "black" }}
              >
                Upload
                <span style={{ color: "red" }}>*</span>
              </Typography>
              
            </Grid>
            <Button
              component="label"
              role={undefined}
              tabIndex={-1}
              sx={{
                borderColor:
                  formik.values.files === null && formik.errors.files
                    ? "#C41C1C"
                    : "none",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: "5px !important",
              }}
              variant="outlined"
              color="neutral"
              startDecorator={
                <SvgIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                    />
                  </svg>
                </SvgIcon>
              }
            >
              {`Upload Files ${formik.values.files?.length > 0
                  ? `(${formik.values.files[0].name})`
                  : ""
                }`}

              <VisuallyHiddenInput
                type="file"
                name="files"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const files = event.target.files;
                  if (files) {
                    const filesArray = Array.from(files);
                    formik.setFieldValue("files", filesArray);
                    // formik.setFieldTouched("files", true);
                    setTimeout(() => {
                      formik.validateField("files");
                    }, 0);
                    event.target.value = "";
                  } else {
                    formik.setFieldValue("files", []);
                    formik.setFieldTouched("files", true, false);
                    formik.validateField("files");
                  }
                }}
              />
            </Button>
            <Grid sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span
              style={{
                color: "gray",
                fontSize: "0.75rem",
                paddingLeft: "2px",
              }}
            >{` ( You can upload only one file - csv)`}</span>
            <Typography
  onClick={handleDownloadSample}
  sx={{
    cursor: "pointer",
    color: "#4D8FAC",
    textDecoration: "underline",
    "&:hover": {
      color: "#3b738a",
    },
  }}
  className="download-sample-link"
>
  Download Sample CSV
</Typography>
</Grid>
            {Boolean(formik.errors.files && formik.touched.files) && (
              <FormHelperText sx={{ fontSize: "1rem", color: "#C41C1C" }}>
                {formik.errors.files}
              </FormHelperText>
            )}
            <Grid
              sx={{
                marginTop: "8px",
                display: "flex",
                gap: "5px",
                width: "100%",
                flexWrap: "wrap",
              }}
            ></Grid>
          </Grid>
          <ReuseableButton
            title="Upload"
            type="submit"
            loading={loading}
            sx={{
              marginRight: "15px",
              width: "100px",
              backgroundColor: "#4D8FAC",
            }}
          />
        </Grid>

        <Grid sx={{ width: "95%", marginTop: "20px" }}>
          <DocumentsTable
            triggerGetCall={triggerGetCall}
            tableName="Users"
            open={openModal}
            setOpen={setOpenModal}
            type="users"
            setData={setUserData}
          />
        </Grid>
      </form>
      {isShowSnackbar && (
        <ReuseableSnackbar
          isShowSnackbar={isShowSnackbar}
          colour={snackbarInfo.color}
          setIsShowSnackbar={setIsShowSnackbar}
          message={snackbarInfo.message}
          autoHideDuration={2000}
        />
      )}

      {showMissingModal && (
        <>
          <ReusableModal
            type={modalType}
            open={showMissingModal}
            setOpen={setShowMissingModal}
            category={missingCategoryMessage}
            setIsProceed={setIsProceed}

          />
        </>
      )}

      {openModal["isOpen"] && (
        <UserModal open={openModal["isOpen"]} setOpen={setOpenModal} type={openModal["type"]} setIsShowSnackbar={setIsShowSnackbar} setSnackbarInfo={setSnackbarInfo} setTrigegerGetCall={setTrigegerGetCall} data={userData} />
      )}
    </div>
  );
};

export default Users;
